import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import CONFIGURACIONES from "../../../util/constants";
import Pagination from "./Pagination";
import { Http } from "../../../helpers/Http";
import WaveButton from "../WaveButton";

const List = ({icon, title, headers, data, fnCreate, fnEdit, fnDelete, setPage, pages, page, setParam, entityPagination, setLimit, showLevelsAprobation, fnApprobal, showEdit, showDelete, showCreate, dataTooltipId, content, showCrearMovimiento, showApertura, showCerrar, fnAperturarCaja, fnCreateMovimiento, fnCerrarCaja, showPrint, fnPrint }) => {
    const [isResponsive, setIsResponsive] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [expandedRow, setExpandedRow] = useState(CONFIGURACIONES.INIT.NULL);
    const [review, setReview] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);

    const searchData = (value) => {
       setParam(value);
       localStorage.setItem('search', true);
       setPage(CONFIGURACIONES.INIT.CURRENT_PAGE);
    //    loadData()
    };

    const setLimitPage = (value) => {
        setLimit(value)
        setPage(CONFIGURACIONES.INIT.CURRENT_PAGE);
    }

    const handleRowToggle = (index) => {
        if (isResponsive && expandedRow === index) {
            setExpandedRow(null);
        } else if (isResponsive || (!isResponsive && review)) {
            setExpandedRow(index);
            if (expandedRow === index) {
                setExpandedRow(null);
            }
        }
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };


    useEffect(() => {
        // showSpinnerLoader();
        // loadData();
        const handleResize = () => {
            setIsResponsive(window.innerWidth <= 767);
        };
        console.log('header length', headers.length);
        
        setReview(headers.length > CONFIGURACIONES.INIT.MAX_COLUMNS_TABLE?CONFIGURACIONES.INIT.STATUS_TRUE:CONFIGURACIONES.INIT.STATUS_FALSE);
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
        <div className="row">
            <div className="col-12">
                <h1 className="h3"><i className={`font-25 mdi ${icon}`}></i> Listado de {title} </h1>
            </div>
            <div className="col-12 section my-lg-1 d-md-flex justify-content-between">
                <input type="text" name="buscar" className="form-control col-sm-12 col-md-2 mx-0" placeholder="Buscar" id="buscar" onChange={(e)=> searchData(e.target.value)} />
                <div className="btn-group">
                    {showCreate && <WaveButton className="btn btn-outline-danger btn-md waves-effect my-2 my-md-0" onClick={fnCreate} dataTooltipId={dataTooltipId} place="left" content={content}>
                        <i className="mdi mdi-plus font-25"></i> Nuevo
                    </WaveButton>}

                    {showApertura && <WaveButton className="btn btn-outline-success btn-md waves-effect my-2 my-md-0" onClick={fnAperturarCaja}>
                        <i className="mdi mdi-plus font-25"></i> Aperturar Caja
                    </WaveButton>}

                    {showCrearMovimiento && <WaveButton className="btn btn-outline-info btn-md waves-effect my-2 my-md-0 ml-1" onClick={fnCreateMovimiento}>
                        <i className="mdi mdi-tag-plus font-25"></i> Crear Movimiento
                    </WaveButton>}

                    {showCerrar && <WaveButton className="btn btn-outline-danger btn-md waves-effect my-2 my-md-0 mx-1" onClick={fnCerrarCaja}>
                        <i className="mdi mdi-close font-25"></i> Cerrar Caja
                    </WaveButton>}

                    {showPrint && <WaveButton className="btn btn-outline-secondary btn-md waves-effect my-2 my-md-0" onClick={fnPrint}>
                        <i className="mdi mdi-printer font-25"></i> Imprimir Cierre
                    </WaveButton>}
                </div>
            </div>
        </div>

        <div className="table-responsive mt-2">
            <table className="table table-md">
                <thead>
                    <tr>
                        {headers.map((header, index)=> (
                            <React.Fragment key={index}>
                                <th className={index <= CONFIGURACIONES.INIT.NUMBER_COLUMNS_TABLE? `desktop-only ${isResponsive && index !== CONFIGURACIONES.INIT.NUMBER? 'mobile-hidden' : ''}`:isResponsive?'mobile-hidden':index < CONFIGURACIONES.INIT.MAX_COLUMNS_TABLE?'desktop-only':'mobile-hidden'}>{header.label}</th>
                            </React.Fragment>
                        ))}
                        <th>OPCIONES</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0? (
                        data.map((row, rowIndex) => (
                           <React.Fragment key={rowIndex}>
                            <tr className={`data-row ${isResponsive && expandedRow === rowIndex ? 'expanded' : ''}`} onClick={() => handleRowToggle(rowIndex)}>
                                { headers.map((header, idx) => (
                                    <td key={idx} className={idx <= CONFIGURACIONES.INIT.NUMBER_COLUMNS_TABLE? `desktop-only 
                                            ${isResponsive && idx !== CONFIGURACIONES.INIT.NUMBER? 'mobile-hidden' : ''}`:isResponsive?'mobile-hidden': idx < CONFIGURACIONES.INIT.MAX_COLUMNS_TABLE?'desktop-only':'mobile-hidden'}>{row[header.key]}</td>
                                ))}
                                
                                {/* Options of table */}
                                <td>
                                    <div className="options">
                                        { showLevelsAprobation && <button className="btn btn-sm btn-info" onClick={(e) => {e.stopPropagation(); fnApprobal(row); }}>
                                            <i className="mdi mdi-account-convert"></i>
                                        </button>}

                                        { showEdit && <button className="btn btn-sm btn-success" onClick={(e) => {e.stopPropagation(); fnEdit(row); }}>
                                            <i className="mdi mdi-pencil"></i>
                                        </button>}

                                        {showDelete && row.id > CONFIGURACIONES.INIT.NUMBER && <button className="btn btn-sm btn-danger" onClick={(e) => {e.stopPropagation(); fnDelete(row)}}>
                                            <i className="mdi mdi-delete"></i>
                                        </button>}
                                    </div>
                                </td>
                            </tr>
                            
                            {isResponsive && expandedRow === rowIndex && (
                            <tr className="expanded-row">
                                <td colSpan={headers.length + 1}>
                                { headers.map((header, idx) => (
                                    idx !== CONFIGURACIONES.INIT.NUMBER && <div className="expanded-content" key={`det_1_${idx}`}>
                                        <div className="expanded-content-item">
                                            <span className="label">{header.label}:</span>
                                            <span className="value">{row[header.key]}</span>
                                        </div>
                                    </div>
                                ))}
                                </td>
                            </tr>
                            )}

                            {!isResponsive && expandedRow === rowIndex && (
                            <tr className="expanded-row">
                                <td colSpan={headers.length + 1}>
                                { headers.map((header, idx) => (
                                    idx >= CONFIGURACIONES.INIT.MAX_COLUMNS_TABLE && <div className="expanded-content"key={`det_2_${idx}`}>
                                        <div className="expanded-content-item">
                                            <span className="label">{header.label}:</span>
                                            <span className="value">{row[header.key]}</span>
                                        </div>
                                    </div>
                                ))}
                                </td>
                            </tr>
                            )}
                        </React.Fragment>
                        ))
                    ):(
                        <tr> 
                            <td colSpan={headers.length + 1} 
                            className="text-center py-4 text-gray-500">{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        <div className="">
            <Pagination pages={pages} page={page} handlePageChange={handlePageChange} setPage={setPage} entity={entityPagination} setLimitPage={setLimitPage}/>
        </div>
    </>
    )
}
export default List;